import { FilterMatchMode } from "primereact/api"

export class Matriz {
    model = {
        id: { value: null, export: false },
        nombre: {
            value: '', export: true, header: 'Nombre', required: 'Campo requerido', maxLength: 'Máximo 300 caracteres',
            filterPlaceholder: 'nombre', minLength: 'Mínimo 4 caracteres', max: 300, min: 3, filterField: 'nombre',
            table: true, filter: true, sort: true, matchMode: FilterMatchMode.CONTAINS
        },
        descripcion: {
            value: '', export: true, header: 'Descripción', required: false, maxLength: 'Máximo 500 caracteres',
            filterPlaceholder: 'Descripción', minLength: 'Mínimo 3 caracteres', max: 500, min: 4, filterField: 'descripcion'
        },
        sigla: {
            value: '', export: true, header: 'Código', required: false, maxLength: 'Máximo 100 caracteres',
            filterPlaceholder: 'Código', minLength: 'Mínimo 3 caracteres', max: 100, min: 4, filterField: 'sigla',
            table: true, filter: true, sort: true, matchMode: FilterMatchMode.CONTAINS
        },
        empresa: { header: 'Empresa', value: '', required: false, optionLabel: 'nombre', export: true, table: true },
        fecha: { header: 'Fecha', value: null, table: true, export: true, filter: true, matchMode: FilterMatchMode.DATE_IS, filterField: 'fecha', isDate: true, },
        tipo_negocio: { header: 'Área / Departamento', value: null, required: 'Seleccione una opción', optionLabel: 'nombre', export: false, table: true, filter: true, filterField: 'tipo_negocio', optionValue: 'cat_id', matchMode: FilterMatchMode.IN, isMultiselect: true, catalogKey: 'areas' },
        estado: { header: 'Estado', value: null, required: false, optionLabel: 'nombre', export: false, table: true },
        apetito_inherente: { header: 'Apetito Inherente', value: null, required: 'Campo requerido', export: true, max: 5, min: 0, },
        tolerancia_inherente: { header: 'Tolerancia Inherente', value: null, required: 'Campo requerido', export: true, max: 5, min: 0, },
        apetito_residual: { header: 'Apetito Residual', value: null, required: 'Campo requerido', export: true, max: 5, min: 0, },
        tolerancia_residual: { header: 'Tolerancia Residual', value: null, required: 'Campo requerido', export: true, max: 5, min: 0, },
    }

    optionLabel = 'nombre'
}
